import { Button, Classes, Icon, IconName, MaybeElement } from "@blueprintjs/core";
import React from "react";
import ReactDOM from "react-dom";
import portal from "./portal";
import styles from "./DraggableDialog.module.scss";
import Draggable from "react-draggable";
import { GlobalEscape } from "modules/common/components/hotkeys/GlobalEscape";

let DialogCounter = 0;

class DraggableDialog extends React.PureComponent<DraggableDialogProps> {
    private counter: number = 0;

    // react-draggable ищет перетаскиваемый узел через ReactDOM.findDOMNode, если
    // ему не дали ссылку. В React 19 этой функции нет: без nodeRef библиотека
    // получает null и на каждое нажатие мыши в диалоге бросает «<DraggableCore>:
    // Unmounted during event!» — окно не тянется за шапку.
    private dialogRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
        DialogCounter++;
        this.counter += DialogCounter;
    }

    componentWillUnmount() {
        DialogCounter = Math.max(0, DialogCounter - 1);
    }

    render() {
        const { isOpen, onClose, width, height, title, icon, initialX, initialY, children } = this.props;

        if (!isOpen) {
            return null;
        }

        const isIconName = typeof icon === "string";
        const isIconElement = !!icon && !isIconName;

        const child1 = (
            <Draggable
                handle={`.${Classes.DIALOG_HEADER}`}
                defaultClassName={`${styles.root} draggable-dialog-${this.counter}`}
                defaultPosition={{ x: initialX ?? window.innerWidth / 2 - width / 2, y: initialY ?? 100 }}
                axis="both"
                offsetParent={document.body}
                nodeRef={this.dialogRef as React.RefObject<HTMLElement>}
            >
                <div
                    ref={this.dialogRef}
                    className={Classes.DIALOG}
                    style={{ width: `${width}px`, height: `${height}px` }}
                >
                    <div className={`${Classes.DIALOG_HEADER} ${styles.header}`}>
                        {isIconName && <Icon icon={icon} />}
                        {isIconElement && icon}

                        {title && <div className={Classes.HEADING}>{title}</div>}
                        {onClose && (
                            <Button
                                minimal={true}
                                className={Classes.DIALOG_CLOSE_BUTTON}
                                icon="small-cross"
                                onClick={onClose}
                            />
                        )}
                    </div>
                    {children}
                </div>
            </Draggable>
        );

        return (
            <>
                {onClose && <GlobalEscape onEscape={this.onClose} label="закрыть диалог" />}
                {ReactDOM.createPortal(child1, portal)}
            </>
        );
    }

    onClose = () => this.props.onClose && this.props.onClose();

}

export { DraggableDialog };

export type DraggableDialogProps = {
    width: number;
    height: number;
    isOpen: boolean;
    initialX?: number;
    initialY?: number;
    title?: React.ReactNode;
    icon?: IconName | MaybeElement;
    onClose?: (event?: React.SyntheticEvent<HTMLElement>) => void;
    children?: React.ReactNode;
};
